import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import {
  PATH_TAXES,
  PATH_TAXES_EDIT_TAX_PROFILE,
  PATH_TAXES_EDIT_TAX_RATE,
  PATH_TAXES_SENT_TO_IRS,
  PATH_TAXES_SURVEY
} from "./paths";
import { RouteEditTaxProfile } from "./routes/RouteEditTaxProfile";
import { RouteEditTaxRate } from "./routes/RouteEditTaxRate";
import { RouteIndex } from "./routes/RouteIndex";
import { RouteSurvey } from "./routes/RouteSurvey";
import { TaxesSendToIRS } from "./routes/TaxesSendToIRS";

export const Taxes: React.FC = () => (
  <Switch>
    <Route path={PATH_TAXES} exact component={RouteIndex} />
    <Route path={PATH_TAXES_SENT_TO_IRS} exact component={TaxesSendToIRS} />
    <Route path={PATH_TAXES_EDIT_TAX_RATE} component={RouteEditTaxRate} />
    <Route path={PATH_TAXES_EDIT_TAX_PROFILE} component={RouteEditTaxProfile} />
    <Route path={PATH_TAXES_SURVEY} component={RouteSurvey} />

    <Redirect from="*" exact to={PATH_TAXES} />
  </Switch>
);
